export const getProtocol = () => window.location.protocol;
